export default __webpack_public_path__ + "static/media/footer-einfach.b590460c.png";